import React from 'react'
import { CreateSupportAnnounce7Container } from '../../containers/Officer/CreateSupportAnnounce7Container'
export const CreateSupportAnnounce7Page = () => {
    return (
        <CreateSupportAnnounce7Container />
    )
}
